module.exports = {"431181001":"龙山街道","431181002":"长虹街道","431181003":"浯溪街道","431181101":"观音滩镇","431181102":"茅竹镇","431181103":"三口塘镇","431181104":"大忠桥镇","431181105":"肖家镇","431181106":"八宝镇","431181107":"白水镇","431181108":"进宝塘镇","431181109":"黄泥塘镇","431181110":"羊角塘镇","431181111":"梅溪镇","431181112":"潘市镇","431181113":"七里桥镇","431181114":"下马渡镇","431181115":"黎家坪镇","431181116":"文富市镇","431181117":"大村甸镇","431181118":"文明铺镇","431181119":"龚家坪镇","431181120":"金洞镇","431181201":"凤凰乡","431181202":"石鼓源乡","431181203":"晒北滩瑶族乡","431181401":"原种场","431181402":"畜牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431181.json
// module id = 2042
// module chunks = 0